<script lang="ts">
	import uqnSplit from './functions/uqnSplit';
	import Fraction from './functions/fractionClass';
	import katexify from './functions/katexify';

	export let uqn: number;
	let ans: string; // ansB: string, ansC: string, ansD: string;
	$: [ans] = uqnToAns2201(uqn);

	function uqnToAns2201(u:number):string[]{
		const [type, direct, k, double] = uqnSplit(u);
		const newXArray = [0.25, 0.5, 2, 3, 4]
		let newX = newXArray[double];
		if (type<4){
			newX = Math.pow(newX,type);
		} else if (type==4){
			newX = newX + 1;
		} else if (type==5){
			newX = Math.pow(newX, 0.5);
		} else{
			newX = Math.pow(newX, 1/3);
		}
		let newY = direct < 4 ? k*newX : k/newX;
		if (direct%4<2){
			return [newY.toFixed(3)];
		} else{
			let oldX = type==4 ? 2 : 1;
			let oldY = direct < 4 ? k*oldX : k/oldX;
			return [`${(Math.abs(oldY-newY)/oldY*100).toFixed(3)}\\\%`];
		}
	}

</script>

<p>
	{@html katexify(ans+".")}
</p>